import { Injectable } from '@angular/core';
import { Geolocation } from "@capacitor/geolocation";
import { ConfigService } from '../config/config.service';
import { GeoLocationErrorHandlerService } from './geo-location-error-handler.service';
import { UtilsService } from '../utils/utils.service';
import { Navigator } from "src/app/services/routing/navigator";

declare var window: any;


@Injectable({
  providedIn: 'root'
})
export class GeoLocationPreRequestService {
  private useNDBSSolution: boolean;

  constructor(
    private utilsService: UtilsService,
    private configService: ConfigService,
    private navigator: Navigator,
    private geoLocationErrorHandlerService: GeoLocationErrorHandlerService
  ) {
    this.useNDBSSolution = this.configService.isFeatureON( this.configService.getConfig(), "FEATURE_GEOCOMPLY_USENODOWNLOAD", undefined);
  }

  public async performGeoLocationPreCheck(): Promise<boolean> {
    return this.verifyLocationPermission();
  }

  private async verifyLocationPermission(): Promise<boolean> {
    const platformInfo = this.utilsService.getPlatformInfo();
    if (platformInfo.isMobileApp) {
      try {
      const permissionStatus = await Geolocation.requestPermissions();
      console.log(permissionStatus);
      switch (permissionStatus.location) {
        case 'granted':
          // Get the current position to check for accuracy
          const position = await Geolocation.getCurrentPosition();
          console.log('Position:', position);

          // Check accuracy on iOS (accuracyAuthorization can be 'full' or 'reduced')
          if (platformInfo.isIosApp) {
            const hasPreciseLocation = position.coords.accuracy < 100; // High accuracy indicates precise location
            if (hasPreciseLocation) {
              console.log('Precise location is enabled');
              return true;
            } else {
              console.log('Precise location is disabled');
              this.geoLocationErrorHandlerService.setGeoComplyError({
                error_code: 637,
                error_message: 'Indicates that the app has turned off precise accuracy location in Settings app',
                troubleshooter_message: 'Precise location is disabled/off.',
                error_details: '',
                geolocate_in: 0,
                hint: undefined,
              });
              return false;
            }
          } else {
           console.log('Android location has granted...Pre Location check has already handled at app launch for Android.');
           return true;
            //Android Precise location logic - Please check current PROD behavior and then make changes
            //Otherwise, it will be part of next release - Work In Progress
            /*const isFineLocationGranted = await Permissions.query({ name: 'geolocation' });
            if (isFineLocationGranted.state === 'granted' && position.coords.accuracy < 100) {
              console.log('Precise location is enabled');
              return true;
            } else {
              console.log('Precise location is disabled');
              console.log('Precise location is disabled');
              this.geoLocationErrorHandlerService.setGeoComplyError({
                error_code: 637,
                error_message: 'Indicates that the app has turned off precise accuracy location in Settings app',
                troubleshooter_message: 'Precise location is disabled/off.',
                error_details: '',
                geolocate_in: 0,
                hint: undefined,
              });
              return false;
            }*/
          }
        case 'denied':
          console.log('************Geolocation permission denied************');
          this.geoLocationErrorHandlerService.setGeoComplyError({
            error_code: 611,
            error_message: 'Geolocation permission denied.',
            troubleshooter_message: 'You have denied location access. Please enable it in your device settings.',
            error_details: '',
            geolocate_in: 0,
            hint: undefined,
          });
          return false;
        case 'prompt':
          console.log('************Geolocation permission prompt state************');
          try {
            const position = await new Promise<GeolocationPosition>((resolve, reject) => {
              navigator.geolocation.getCurrentPosition(resolve, reject);
            });
            console.log('************Geolocation granted************', position);
            return true;
          } catch (error) {
            console.error('************Geolocation permission denied or error occurred************', error);
            this.geoLocationErrorHandlerService.setGeoComplyError({
              error_code: 611,
              error_message: "Geolocation permission denied.",
              troubleshooter_message: "<troubleshooter><message retry=\"0\" rule=\"boundary\">You have denied location access. Please enable it in your browser settings.</message></troubleshooter>",
              error_details: "<error_details><boundary description=\"This user does not appear to be within an inclusion zone\" type=\"out_of_boundary\"/></error_details>",
              geolocate_in: 0,
              hint: undefined,
            });
            return false;
          }
        default:
          console.log('************Geolocation permission state is unknown************');
          return false;
      }
    }
    catch (error) {
      console.error('Error requesting location permissions:', error);
      this.geoLocationErrorHandlerService.setGeoComplyError({
        error_code: 611,
        error_message: 'Geolocation permission denied.',
        troubleshooter_message: 'You have denied location access. Please enable it in your device settings.',
        error_details: '',
        geolocate_in: 0,
        hint: undefined,
      });
      return false;
    }
    } else if (this.useNDBSSolution && !platformInfo.isMobileApp) {
      const permissionStatus = await navigator.permissions.query({ name: 'geolocation' });
      console.log(permissionStatus);
      switch (permissionStatus.state) {
        case 'granted':
          return true;
        case 'denied':
          console.log('************Geolocation permission denied************');
          this.geoLocationErrorHandlerService.setGeoComplyError({
            error_code: 803,
            error_message: 'Geolocation permission denied.',
            troubleshooter_message: 'You have denied location access. Please enable it in your browser settings.',
            error_details: '',
            geolocate_in: 0,
            hint: undefined,
          });
          return false;
        case 'prompt':
          console.log('************Geolocation permission prompt state************');
          try {
            const position = await new Promise<GeolocationPosition>((resolve, reject) => {
              navigator.geolocation.getCurrentPosition(resolve, reject);
            });
            console.log('************Geolocation granted************', position);
            return true;
          } catch (error) {
            console.error('************Geolocation permission denied or error occurred************', error);
            this.geoLocationErrorHandlerService.setGeoComplyError({
              error_code: 803,
              error_message: "Geolocation permission denied.",
              troubleshooter_message: "<troubleshooter><message retry=\"0\" rule=\"boundary\">You have denied location access. Please enable it in your browser settings.</message></troubleshooter>",
              error_details: "<error_details><boundary description=\"This user does not appear to be within an inclusion zone\" type=\"out_of_boundary\"/></error_details>",
              geolocate_in: 0,
              hint: undefined,
            });
            return false;
          }
        default:
          console.log('************Geolocation permission state is unknown************');
          return false;
      }
    } else {
      return true;
    }
  }

  //Android App specific methods
  public shouldDisplayPermissionReason(): boolean {
    const platformInfo = this.utilsService.getPlatformInfo();
    return (platformInfo.isAndroidApp && !this.didAcceptReason());
  }

  public setAcceptReason(didAccept) {
    window.localStorage.setItem("geocomply_didAcceptPermissionReason", 0 + didAccept);
  }

  public didAcceptReason() {
    var didAccept = window.localStorage.getItem("geocomply_didAcceptPermissionReason");
    return !!parseInt(didAccept);
  }

  public displayPermissionReason(): Promise<boolean> {
    return new Promise((resolve) => {
      const cssClass = "standard-popover";
      const popoverPromise = this.navigator.openPopover(
        "PreGeoInfoPopover",
        {},
        cssClass
      );

      popoverPromise.then((popover) => {
        if( popover) {
          popover!.onDidDismiss().then((data:any) => {
            console.log("Geolocation: Permission popover dismiss:", data);
            // this.setAcceptReason(!!data);
            resolve(data);
          });
        }
      });
    });
  }

}